import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { getDirection } from "../../../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../../../common-deprecated/styles/lexus/Button";
import * as MonthlyPrice from "../price/styles/MonthlyPrice";
import * as PricePromoIcon from "../price/styles/PricePromoIcon";
import * as CashPrice from "../price/styles/CashPrice";
import Disclaimer from "../../../../../../../common-deprecated/styles/lexus/Disclaimer";
import { parseHexToRGB } from "../../../../../../../common-deprecated/utils";

const TEXT_COLOR = "#585D5F"; /* Specific color */
const BORDER_COLOR = parseHexToRGB("#A8AAAC").rgb;

type ListItemValueProps = {
    hasPrice?: boolean;
    hasRemoveButton?: boolean;
};

export const Wrapper = styled.div<SpaceProps>`
    width: 100%;
    ${space};
`;

export const Header = styled.div`
    margin-bottom: 6px;
    font-family: ${({ theme }) => theme.fontFamily.bold};
    font-size: 1.3rem;
    color: ${TEXT_COLOR};
`;

export const Content = styled.dl<ListItemValueProps>`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin: 12px 0;

    dt, dd {
        padding: 12px 0;
        font-weight: normal;
        border-bottom: 1px solid rgba(${BORDER_COLOR}, 0.5);
        &:nth-child(1),
        &:nth-child(2) {
            border-top: 1px solid rgba(${BORDER_COLOR}, 0.5);
        }
    }

    dt {
        display: inline-block;
        width: 65%;
        font-size: 1.3rem;
        ${({ theme }) => css`
            font-family: ${theme.fontFamily.regular};
            color: ${TEXT_COLOR};
        `};

        button {
          padding: 0;
        }
    }

    dd {
        display: flex;
        position: relative;
        flex: 1 0 auto;
        flex-direction: ${({ hasPrice }) => (hasPrice ? "column" : "row")};
        align-items: flex-start;
        align-self: stretch;
        justify-content: flex-end;
        width: 35%;
        margin: 0;
        font-size: 1.3rem;
        text-align: ${getDirection("right")};
        color: ${TEXT_COLOR};
        ${CashPrice.Text} {
            align-self: flex-end;
            margin-top: 0;
            padding-top: 3px;
            padding-${getDirection("right")}: ${({ hasRemoveButton }) => (hasRemoveButton ? "20px" : "0")};
            font-family: ${({ theme }) => theme.fontFamily.regular};
            font-size: 1.3rem;
            color: ${({ theme }) => theme.color.dark};
        }
        ${CashPrice.TextLineThrough} {
            color: ${({ theme }) => theme.color.grey3};
        }
        ${MonthlyPrice.Text} {
            align-self: stretch;
            padding-${getDirection("right")}: ${({ hasRemoveButton }) => (hasRemoveButton ? "20px" : "0")};
            text-align: ${getDirection("right")};
            color: ${({ theme }) => theme.color.dark};
        }
        ${PricePromoIcon.Wrapper} {
            position: absolute;
            ${getDirection("right")}: -${({ theme }) => theme.space[2]}px;
        }
        ${Button.Link} {
            min-width: 20px;
            min-height: 20px;
            margin-top: 2px;
            margin-${getDirection("left")}: auto;
            margin-${getDirection("right")}: 0;
        }
        ${Disclaimer} {
            padding-${getDirection("right")}: ${({ hasRemoveButton }) => (hasRemoveButton ? "20px" : "0")};
        }
    }

    /* Styling for InternalLink components in the basket */
    a {
        font-size: 1.3rem;
        text-decoration: underline;
    }

    ${Button.Link} {
        /* popover */
        margin: 0 2px;
    }

`;
